module.exports = __webpack_public_path__ + "img/teacher_8.b6f7198b.png";